import { AiConversationStatus } from 'common-billing-server/types'

/** Long silence is missing completion evidence, not proof that the installation's worker is still running. */
export const hasUnconfirmedCompletion = (status: AiConversationStatus, updatedAt: Date): boolean =>
    [AiConversationStatus.pending, AiConversationStatus.running].includes(status) &&
    Date.now() - new Date(updatedAt).getTime() > 15 * 60_000

export const conversationStatusLabel = (status: AiConversationStatus, updatedAt: Date): string =>
    hasUnconfirmedCompletion(status, updatedAt) ? 'Completion unconfirmed' : status
